import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NotBusinessComponent } from './not-business.component';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: '',
        component: NotBusinessComponent
      }
    ])
  ],
  exports: [RouterModule]
})
export class NotBusinessRoutingModule {
}
